import { TFunction } from 'i18next';
import salesImage from '/public/store-products/landing/sales.png';
import beautyImage from '/public/store-products/landing/beauty.png';
import gymImage from '/public/store-products/landing/gym.png';
import cafeImage from '/public/store-products/landing/cafe.png';
import contractorImage from '/public/store-products/landing/contractor.png';
import denticalImage from '/public/store-products/landing/dentical.png';

const images = [salesImage, beautyImage, gymImage, cafeImage, contractorImage, denticalImage];

export const getUseCases = (t: TFunction) => {
  const cases = t('store.productPage.useCases', { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  return cases?.map?.((useCase, index) => ({
    ...useCase,
    imageSrc: images[index]!,
  }));
};
